import { Observable } from "rxjs";

export interface ICreateGroupService {
  /** proposed group names (portal) */
  readonly proposedGroupNames$: Observable<IGroupName[]>;
  /** is there proposed group names*/
  readonly hasProposedGroupNames$: Observable<boolean>;
  /** the number of table groups is greater than 0*/
  readonly groupExists$: Observable<boolean>;
  /**can create group : group count of the table is less then max Group count */
  readonly canCreateGroup$: Observable<boolean>;
  /** initialiesert die informationen aus den übergebenen Daten */
  initial(tableQrCode: string): Promise<void>;
  /** erstellt die gruppe, leitet automatisch weiter, wenn erfolgreich */
  createGroup(group_name: string, nickname: string): Promise<CreateGroupResult>;
}

export interface IGroupName {
  readonly name: string;
}

/** crate group result */
export enum CreateGroupResult {
  /** User an Platz zu setzen war erfolgreich */
  Okay,
  /** User an Platz zu setzen war nicht möglich */
  Fail,
  /** Username ist falsch, vergeben oder gesterrt */
  WrongUserName,
  /** Gruppenname ist falsch, vergeben oder gesterrt */
  WrongGroupName,
  /** Gruppenlimit für Tisch erreicht */
  TableFull
}